import React from 'react';

/** NAV-FE-1b — what a route shows while its page's chunk loads (the spinner `LotDetail.jsx` uses). */
export default function RouteFallback() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center" data-testid="route-fallback">
      <div className="animate-spin h-8 w-8 border-2 border-orange-500 border-t-transparent rounded-full" />
    </div>
  );
}
